import { IAnalytcisUserInput } from "../typings/IAnalyticsUserInput";

export const analyticsUserInput: IAnalytcisUserInput = {
    TidalLevel: {
        dataset: null,
        variable: null,
        startDate: null,
        endDate: null
    },
    TimeSeriesPlot: {
        dataset: null,
        variable: null,
        startDate: null,
        endDate: null
    },
    ScatterPlot: {
        datasetX: null,
        datasetY: null,
        variableX: null,
        variableY: null,
        month: 0,
        startDate: null,
        endDate: null
    },
    RosePlot: {
        dataset: null,
        variable: null,
        direction: null,
        month: 0,
        startDate: null,
        endDate: null,
        directionNo: 24,
        legendInterval: 0
    },
    ScatterTable: {
        datasetX: null,
        datasetY: null,
        variableX: null,
        variableY: null,
        startDate: null,
        endDate: null,
        month: "All",
        intervalX: 24,
        intervalY: 24,
    },
    Persistence: {
        datasetX: null,
        datasetY: null, // conditionalDataset
        variableX: null,
        variableY: null,
        sign: "below",
        sign2: "below",
        percentile: 50,
        duration: 1,
        threshold: null,
        threshold2: null,
        startDate: null,
        endDate: null,
        conditionalDSSelected: false,
    },
    ExtremeValues: {
        dataset: null,
        variable: 0,
        startDate: null,
        endDate: null,
    },
    Histogram: {
        dataset: null,
        month: 'All',
        variableX: null,
        variableY: null,
        startDate: null,
        endDate: null,
    },
    Statistics: {
        dataset: null,
        variable: null,
        startDate: null,
        endDate: null
    },
    Exceedance: {
        dataset: null,
        variable: null,
        startDate: null,
        endDate: null
    }
}